import React, { Component } from 'react';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';
import BinarySelect from '../../../../components/BinarySelect'
import MultiSelect from '../../../../components/FormElements/MultiSelect'

import Input from '../../../../components/FormElements/Input';
// import File from '../../../../../components/FormElements/File';
import Textarea from '../../../../components/FormElements/Textarea';
import Select from '../../../../components/FormElements/Select';
import Datepicker from '../../../../components/FormElements/Datepicker';
import ModalConfirmation from '../../../../components/ModalConfirmation';
// import MultiSelect from '../../../components/FormElements/MultiSelect';
import TimePicker from '../../../../components/FormElements/TimePicker';
import { handleFieldError, initializeForm, handleError } from '../../../../utils/form-validation';
import { formFields, confirmationMessage, successfullyMessage, platformtype, dvPlatform, IONplatform, Goal,campaignOptions, roStaus } from './constant';
// import { bidderReport } from '../Io/constant';
import { addIoReportAction,getCountUnMappedCampaignAction,getIoAdvertisersReportAction, getIoEditIdReportAction, getCategoryAction, getSUbCategoryAction, getPrimaryGoalAction, getSecondaryGoalAction, createRoAction, getRoListByIdAction, updateRoAction, uploadFileAction } from '../../../../actions';
import { sortArray } from '../../../../selectors';
import CheckboxGroup from '../../../../components/FormElements/CheckboxGroup';
import SelectNew from '../../../../components/FormElements/SelectNew';
import RadioGroup from '../../../../components/FormElements/RadioGroup'
import { log } from 'async';
import "../ro.scss"
import { imageUrl } from "../../../../constants/configuration";
// import BinarySelect from '../../../components/BinarySelect'
import ToastModal from "../../../../components/ToastModal";
import Table from '../../../../components/CustomTable';

const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));

class AddRo extends Component {
  constructor(props) {
    super(props);
    this.fileRef = React.createRef();
    this.state = {
      roForm: {
        edate: moment(Date.now()).add(90, 'days').toDate(),
        sdate: new Date(),
      },
      form: {},
      touched: {},
      errors: {},
      editMode: false,
      submited: false,
      confirmationOpen: false,
      confirmationInfo: '',
      categoryData: [],
      primaryGoalData: [],
      secondaryGoalData: [],
      googleAds: [{ masterAccountID: "", goggleAdvertiserID: "", currency: "" }],
      facebookAds: [{ fbAccountID: "", fbCurrency: "" }],
      dv360Ads: [{ dv360AccountID: "", dv360Currency: "" }],
      ionAds: [{ ionAccountID: "", ionCurrency: "" }],
      platformCheck: [],
      platforms: [],
      googleCheck: [],
      facebookCheck: [],
      dv360Check: [],
      ionDataCheck: [],
      advertiserCreate: {
        advertisersPlatforms: [],
      },
      primaryGoalId: null,
      secondaryGoalId: null,
      mappedCampaigns: [],
      creativeUrl: '',
      advertiserFilter: [],
      toastStatus: "",
      toastMsg: "",
      enableToast: "",
      path: "",
      confirmationMsg: "",
      renderFileUpload:false
    };
  }

  async componentWillMount() {
    const { match: { params: { id } }, tenantId, authToken, userId, getIoAdvertisersReportAction, configurationList } = this.props;
    
    const { roForm } = this.state;
    // console.log("preSignInData", preSignInData);
    const currency = get(configurationList.find(currency => currency.attrName === 'CURRENCY'), 'attributeValues', []);
    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.props;
      history.push(routes.preSignIn);
    }
    const { form, errors } = initializeForm(formFields);

    // form.campaigncategory = "NEW";
    let curreValue = currency.find(a => a.value == "USD");
    if (curreValue) {
      form.currency = curreValue.key;
    }
    // form.startDate = moment().toDate();
    // form.endDate = moment(new Date().setDate(new Date().getDate() + 90)).toDate();
    form.startDate = new Date()
    form.endDate = moment(Date.now()).add(90, 'days').toDate()
    // form.advertiserId = tenantId;
    this.setState({ form, errors });
    // await this.getUnmappedCampaignCount();
    await getIoAdvertisersReportAction(tenantId, authToken, userId);
    await this.categoryApiFunction();
    await this.primaryGoalApiFunction();
    await this.editId();

    const { preSignInData, ioAdvertisersReport } = this.props;

    if (preSignInData.length > 0 && ioAdvertisersReport.length > 0) {
      const selectedTenantId = preSignInData.find(item => item.tenantId === tenantId);

      const advertiserFilter = ioAdvertisersReport.filter(ele => ele.key == selectedTenantId.tenantId);
      if (advertiserFilter.length == 1) {

        this.setState(prevState => ({
          advertiserFilter:advertiserFilter,
          form: {
            ...prevState.form,
            advertiserId: advertiserFilter[0].key,
          },
        }));
        // this.setState({ advertiserFilter: advertiserFilter, form })
      }

      if(!id) 
      {
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            status:1
          },
        }));
      }
    }
  }

    getUnmappedCampaignCount = async () => {
    const { getCountUnMappedCampaignAction, tenantId, authToken, userId, countUnmapped } =
      this.props;
      if(countUnmapped == undefined){
        await getCountUnMappedCampaignAction({
          tenantId,
          authToken,
          userId,
        });
      }
  };

  editId = async () => {
    const { match: { params: { id } }, tenantId, authToken, ioAdvertisersReport, userId, getRoListByIdAction } = this.props;
    let { form, categoryData, primaryGoalData, secondaryGoalData, roroFormForm } = this.state;

    if (id) {
      const roId = id;
      const {
        responseCode: { status = "" },
        responseList,
      } = await getRoListByIdAction({
        tenantId,
        authToken,
        userId,
        roId
      });
      if (status === "Success" && responseList.length > 0) {

        let { categoryId, subCategoryId, status, totalBudget, name, goalValue, mappedCampaigns, sDate, eDate,SubCategoryValue  } = responseList[0];

        if (mappedCampaigns != undefined && mappedCampaigns.length > 0) {
          mappedCampaigns.forEach((item,index) => {
            // item.index=index
            if (item.url === ' ') {
              item.url = item.url.replace(/\s/g, '')
            }
          })
        }

        this.setState({ mappedCampaigns: mappedCampaigns })

        const roAdvertiser = ioAdvertisersReport.find(advertiser => advertiser.key == tenantId);

        const cat = categoryData.find(item => item.id == categoryId);

        await this.subCategoryApiFunction(cat.id)

        await this.secondaryApiFunction(goalValue.primaryGoal.id)

        const { subCategoryData, secondaryGoalData } = this.state;

        const subCat = subCategoryData != undefined && subCategoryData.find(item => item.categoryID === subCategoryId);

        const secondaryGoal = goalValue.secondaryGoal != undefined && goalValue.secondaryGoal;

        const secGoal = secondaryGoalData.find(item => item.id == secondaryGoal.id);

        const goalSet = primaryGoalData != undefined && primaryGoalData.find(item => item.id == goalValue.primaryGoal.id);
        this.setState({ primaryGoalId: goalSet.id })


        this.setState({ secondaryGoalId: secGoal && secGoal.id })
        form.advertiserId = roAdvertiser != undefined && +roAdvertiser.key;
        // form.budget = totalBudget;
        form.campaigncategory = cat.id;
        form.roName = name;
        form.status = status == 0 ? "0" : "1";
        form.subCampaigncategory = SubCategoryValue;
        form.primaryGoal = goalSet.id;
        form.targetValuePrimary = goalValue.primaryGoal.targetValue;
        form.tolerancePrimary = goalValue.primaryGoal.tolerance;
        form.secondryGoal = secGoal && secGoal.id;
        form.targetValueSecondry = secondaryGoal.targetValue;
        form.toleranceSecondry = secondaryGoal.tolerance;

        form.startDate = new Date(sDate);
        form.endDate = new Date(eDate);

        const sdate = new Date(sDate);
        const edate = eDate != undefined ? new Date(eDate) : "";

        this.setState({
          ...this.state,
          roForm: { ...this.state.roForm, sdate: sdate, edate: edate },
        });

        this.setState({ form });
      }
    }
  };

  // handleChange = (e) => {
  //   let { form, categoryData, primaryGoalData, secondaryGoalData, subCategoryData } = this.state;
  //   let { value, name } = e.target;
  //   form[name] = value;
  //   this.setState({ form },()=>{
  //     if (name === "campaigncategory") {
  //       const categoryValue = value;
  //       const filterCategory = categoryData.find(cat => cat.text === categoryValue);
  //       form.campaigncategory = filterCategory.id
  //       form.subCampaigncategory = ""
  //       this.setState({ form })
  //       this.subCategoryApiFunction(filterCategory.id)
  //     }
  
  //     if (name === "subCampaigncategory") {
  //       form.subCampaigncategory = value;
  //       this.setState({ form });
  //     }
  
  
  //     if (name === "primaryGoal") {
  //       const primaryGoalValue = value;
  //       const filterPrimaryGoal = primaryGoalData.filter(goal => {
  //         return goal.value === primaryGoalValue
  //       })
  
  //       if (filterPrimaryGoal.length > 0) {
  //         filterPrimaryGoal.map(data => {
  //           this.setState({ primaryGoalId: data.id })
  //           this.secondaryApiFunction(data.id)
  //         })
  //       }
  //       form.secondryGoal= ''
  //       this.setState({form})
  //     }
  
  //     if (name === "secondryGoal") {
  //       const secondaryGoalValue = value;
  //       const filterSecondaryGoal = secondaryGoalData.filter(goal => {
  //         return goal.value === secondaryGoalValue
  //       })
  
  //       if (filterSecondaryGoal.length > 0) {
  //         filterSecondaryGoal.map(secData => {
  //           this.setState({ secondaryGoalId: secData.id })
  //         })
  //       }
  
  //     }
  
  //      if (name == "startDate") {
  //       if (form.endDate && value > form.endDate) {
  //         form.endDate = "";
  //       }
  //     }
  //     if(name == "status"){
  //       this.handleTouch({target:{name:name,value:value}})
  //     }



  //   });

  // };


  handleChange = async (e) => {
    let { form, categoryData, primaryGoalData, secondaryGoalData, subCategoryData } = this.state;
    let { value, name } = e.target;
    if(name== "targetValuePrimary" || name=="targetValueSecondry"){
       if(value < 0){
        form[name] = 0;
       }
       else{
        form[name] = value;
       }
    }
    else{
    form[name] = value;
    }
    // console.log(value);
  
    if (name === "campaigncategory") {
      const categoryValue = value;
      const filterCategory = categoryData.find(cat => cat.text == categoryValue);
      form.campaigncategory = filterCategory.id;
      form.subCampaigncategory = "";
      this.subCategoryApiFunction(filterCategory.id);
    } else if (name === "subCampaigncategory") {
      form.subCampaigncategory = value;
    } else if (name === "primaryGoal") {
      const primaryGoalValue = value;
      const filterPrimaryGoal = primaryGoalData.filter(goal => goal.id == primaryGoalValue);
      // console.log("primary",primaryGoalData)
  
      if (filterPrimaryGoal.length > 0) {
        filterPrimaryGoal.forEach(data => {
          this.setState({ primaryGoalId: data.id });
          this.secondaryApiFunction(data.id);
        });
      }
      form.secondryGoal= '';
    } else if (name === "secondryGoal") {
      const secondaryGoalValue = value;
      const filterSecondaryGoal = secondaryGoalData.filter(goal => goal.value === secondaryGoalValue);
  
      // console.log(filterSecondaryGoal);

      if (filterSecondaryGoal.length > 0) {
        filterSecondaryGoal.forEach(secData => {
          this.setState({ secondaryGoalId: secData.id });
        });
      }
      else{
        this.setState({ secondaryGoalId: -1});
      }
    } else if (name === "startDate") {
      if (form.endDate && value > form.endDate) {
        form.endDate = "";
      }
    } else if (name === "status") {
      this.handleTouch({target: {name: name, value: value}});
    }
  
    await this.setState({ form },()=>{
      if(name=="subCampaigncategory"){
        this.handleTouch({target:{name:"subCampaigncategory"}})
      }
      if(name=="primaryGoal"){
        this.handleTouch({target:{name:"primaryGoal"}})
      }
    });
  };
  

  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };

  confirmationCallBack = (success, info) => {
    const { confirmationOpen } = this.state;
    const { match: { params: { id } } } = this.props;
    if (success && info.action.type === 'Confirmation') {
      if (id) {
        this.updateRO();
      } else {
        this.createRO();
      }
    } else if (info.action.type === 'alert') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push('/' + routes.mainRoute + '/' + routes.containers.goals + '/' + routes.containers.ro);
      });
      return;
    } else if (info.action.type === 'Success') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push('/' + routes.mainRoute + '/' + routes.containers.goals + '/' + routes.containers.ro);
      });
      return;
    }
    this.setState({ confirmationOpen: false });
  };

  async submitForm() {
    const { match: { params: { id } }, addIoReportAction, tenantId, authToken, userId } = this.props;
    const { form } = this.state;
    const { advertiserId, brief, startDate, endDate, name, budget } = form;
    let addParams = { addup: 'auto' };
    let data = {
      advertiserId,
      brief,
      startDate: moment(startDate).format('MMM DD, YYYY'),
      endDate: endDate ? moment(endDate).format('MMM DD, YYYY') : null,
      // endDate: endDate === '' ? moment('Dec 31, 2050', 'MMM DD, YYYY').format('MMM DD, YYYY') : moment(endDate).format('MMM DD, YYYY'),
      name: name.replace(/^\s+|\s+$/gm, ''),
      // budget,
      rec_active: 1,
      currency: [{ currency: form.currency, ti_isactive: 1 }],
      geo: [],
    };
    if (id) {
      addParams = { addup: id };
    }
    // console.log(data)
    // return false
    const { desc = '', status = '' } = await (addIoReportAction(tenantId, authToken, userId, data, addParams) || '');

    if (status === 'Success') {
      this.setState({ confirmationOpen: false }, () => {
        this.toggleModal(successfullyMessage);
      });
      return;
    } else {
      const info = { action: { confirmationMessage: desc, type: 'error' } };
      this.toggleModal(info);
    }
  }

  // ========== fetch category ===========
  categoryApiFunction = async () => {
    const { tenantId, authToken, userId, getCategoryAction, configurationList } = this.props;
    const { form, errors } = initializeForm(formFields);
    const {
      responseCode: { status = "" },
      responseList,
    } = await getCategoryAction({ tenantId, authToken, userId });
    if (status == "success") {
      const categoryListDropdownData = responseList.map((item, index) => {
        return { text: item.value, id: item.id };
      });
      if (categoryListDropdownData.length == 1)
      {
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            campaigncategory: categoryListDropdownData[0].id,
          },
        }));

      }
      this.setState(prevState => ({
        categoryData: categoryListDropdownData,
      }));
    }
  }

  // ================= fetch sub-category by id ==============
  // subCategoryApiFunction = async (cateID) => {
  //   const { tenantId, authToken, userId, getSUbCategoryAction, configurationList } = this.props;
  //   const {
  //     responseCode: { status = "" },
  //     responseList,
  //   } = await getSUbCategoryAction({ tenantId, authToken, cateID, userId });
  //   if (status == "success") {
  //     const subCategoryListDropdownData = responseList.map((item, index) => {
  //       return { text: item.value, categoryID: item.id };
  //     });
  //     if (subCategoryListDropdownData.length == 1 )
  //     {
  //       this.setState(prevState => ({
  //         form: {
  //           ...prevState.form,
  //           subCategory: subCategoryListDropdownData[0].text,
  //         },
  //       }));

  //     }
  //     this.setState({ subCategoryData: subCategoryListDropdownData });
  //   }

  // }


  subCategoryApiFunction = async (cateID) => {
    const { tenantId, authToken, userId, getSUbCategoryAction, configurationList } = this.props;
    const {
      responseCode: { status = "" },
      responseList,
    } = await getSUbCategoryAction({ tenantId, authToken, cateID, userId });
    
    if (status === "success") {
      const subCategoryListDropdownData = responseList.map((item, index) => {
        return { text: item.value, categoryID: item.id };
      });
      
      if (subCategoryListDropdownData.length == 1) {
        const firstSubCategory = subCategoryListDropdownData[0].text;
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            subCampaigncategory: firstSubCategory,
          },
          subCategoryData: subCategoryListDropdownData,
        }));
      } else {
        this.setState({
          subCategoryData: subCategoryListDropdownData,
        });
      }
    }
  };
  

  // =============== fetch primary goals ==============
  // primaryGoalApiFunction = async () => {
  //   const { tenantId, authToken, userId, getPrimaryGoalAction, configurationList } = this.props;
  //   const {
  //     responseCode: { status = "" },
  //     responseList,
  //   } = await getPrimaryGoalAction({ tenantId, authToken, userId });
  //   if (status == "success") {
  //     // console.log("responseList", responseList);
  //     if (responseList.length > 0){
  //       this.setState(prevState => ({
  //         form: {
  //           ...prevState.form,
  //           primaryGoal: responseList[0].value,
  //         },
  //       }));
  //     }
  //     this.setState({ primaryGoalData: responseList });
  //   }
  // }

  primaryGoalApiFunction = async () => {
    const { tenantId, authToken, userId, getPrimaryGoalAction, configurationList } = this.props;
    const {
      responseCode: { status = "" },
      responseList,
    } = await getPrimaryGoalAction({ tenantId, authToken, userId });
    
    if (status === "success") {
      if (responseList.length == 1) {
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            primaryGoal: responseList[0].value,
          },
          primaryGoalData: responseList,
        }), () => {
          // Call secondaryApiFunction with the first primary goal ID after setting primaryGoalData
          this.secondaryApiFunction(responseList[0].id);
        });
      }
      else {
        this.setState({
          primaryGoalData: responseList,
        });
      }
    }
  };
  

  // ================= fetch secondary-goals by id ==============
  // secondaryApiFunction = async (primaryGoalID) => {
  //   const { tenantId, authToken, userId, getSecondaryGoalAction, configurationList } = this.props;
  //   const {
  //     responseCode: { status = "" },
  //     responseList,
  //   } = await getSecondaryGoalAction({ tenantId, authToken, primaryGoalID, userId });
  //   if (status == "success") {
  //     if (responseList.length > 0){
  //       this.setState(prevState => ({
  //         form: {
  //           ...prevState.form,
  //           secondaryGoal: responseList[0].value,
  //         },
  //       }));
  //     }
  //     this.setState({ secondaryGoalData: responseList });
  //   }

  // }


  secondaryApiFunction = async (primaryGoalID) => {
    const { tenantId, authToken, userId, getSecondaryGoalAction, configurationList } = this.props;
    const {
      responseCode: { status = "" },
      responseList,
    } = await getSecondaryGoalAction({ tenantId, authToken, primaryGoalID, userId });
    
    if (status === "success") {
      if (responseList.length == 1) {
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            secondryGoal: responseList[0].value,
          },
          secondaryGoalData: responseList,
        }));
      }
      else {
        this.setState({
          secondaryGoalData: responseList,
        });
      }
    }
  };


  reset = () => {
    return {
      advertiserId: '',
      brief: '',
      startDate: '',
      endDate: '',
      name: '',
      // budget: '',
      currency: '',
    };
  };

  // ======== create RO =========
  createRO = async () => {
    const { form, roForm, primaryGoalId, secondaryGoalId, subCategoryData } = this.state;

       const subCategory = form.subCampaigncategory;
        const findSubCat = subCategoryData.find(item => item.text == subCategory);
    const payload = {
      Ro: {
        advertiser: form.advertiserId,
        name: form.roName,
        categoryId: form.campaigncategory,
        subCategoryId: findSubCat.categoryID,
        // totalBudget: +form.budget,
        status: form.status == 0 ? 0 : 1,
        sDate: moment(form.startDate).format("YYYY-MM-DD"),
        eDate: moment(form.endDate).format("YYYY-MM-DD"),
        goalValue: {
          primaryGoal: {
            id: primaryGoalId,
            targetValue: +form.targetValuePrimary,
            tolerance: +form.tolerancePrimary,
          },
          secondaryGoal: {
            id: secondaryGoalId ? secondaryGoalId : -1,
            targetValue: +form.targetValueSecondry,
            tolerance: +form.toleranceSecondry
          }
        }
      }
    };

    const { tenantId, authToken, userId, createRoAction, history, match } =
      this.props;

      // console.log(payload);

      // return;

    const {
      responseCode: { status = "", msg = "" },
      // responseList,
    } = await createRoAction({
      tenantId,
      authToken,
      userId,
      payload
    });

    if (status) {
      this.toast(status, msg);
    }
  }

  // =========== update RO =============
  updateRO = async () => {
    const { form, mappedCampaigns, primaryGoalId, secondaryGoalId, roForm, subCategoryData } = this.state;

    const { match: { params: { id } }, tenantId, authToken, userId, updateRoAction, history, match } = this.props;

    const subCategory = form.subCampaigncategory;
    const findSubCat = subCategoryData.find(item => item.text == subCategory);

    const payload = {
      id: +id,
      advertiser: form.advertiserId,
      name: form.roName,
      categoryId: form.campaigncategory,
      subCategoryId: findSubCat.categoryID,
      // totalBudget: +form.budget,
      status: form.status == 0 ? 0 : 1,
      lastUpdate: moment(form.startDate).format("YYYY-MM-DD"),
      // sDate: moment(roForm.sdate).format("YYYY-MM-DD"),
      eDate: moment(form.endDate).format("YYYY-MM-DD"),
      // eDate: moment(roForm.edate).format("YYYY-MM-DD"),
      goalValue: {
        primaryGoal: {
          id: primaryGoalId,
          targetValue: +form.targetValuePrimary,
          tolerance: +form.tolerancePrimary,
        },
        secondaryGoal: {
          id: secondaryGoalId ? secondaryGoalId : -1,
          targetValue: +form.targetValueSecondry,
          tolerance: +form.toleranceSecondry
        }
      },
      mappedCampaigns: mappedCampaigns
    };

    const {
      responseCode: { status = "", msg = "" },
      // responseList,
    } = await updateRoAction({
      tenantId,
      authToken,
      userId,
      payload
    });


    if (status) {
      this.toast(status, msg);
    }
  }

  // ====== delete campaign =========
  deleteCampaign = (campaignId) => {
    const { mappedCampaigns } = this.state;
    var mappedCampaignsFilter = mappedCampaigns.filter(x => {
      return x.campaignId != campaignId;
    })

    this.setState({ mappedCampaigns: mappedCampaignsFilter })
  }

  toggleAlertModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation })
  }

  filesUpload = async (e, index) => {
    const urlName = e.target.name;
    let { uploadFileAction, ioAdvertisersReport } = this.props;
    const { form, mappedCampaigns } = this.state;
    const data = new FormData();

    const blob = e.target.files[0];
    if (blob && blob.type && blob.type.length > 0 && blob.type.toLowerCase().includes('image')) {
    data.append('file', blob, blob.name);

    const response = await uploadFileAction(data, form.advertiserId, 'image');
    if (response && response.responseCode && response.responseCode.status === 'Success') {
      let img = new Image();
            img.src = window.URL.createObjectURL(blob);
            img.onload = () => {
              if(img.width == 300 && img.height == 250){
              const list = [...mappedCampaigns];
              list[index][urlName] = response.responseList;
              this.setState({ mappedCampaigns: list });
              }
              else{
                this.setState({ enableToast: true,  toastMsg: "Image dimentions should be 300 X 250", toastStatus: "Fail"  });
              }
            }
    } else {
      let info = { action: { confirmationMessage: response.responseCode.desc, type: 'error' } }
      this.toggleAlertModal(info);
    }
   }
   else{
    this.setState({ enableToast: true,  toastMsg: "Invalid file type", toastStatus: "Fail"  });
   }
  }

  renderFileUploadButton(){
    this.setState({renderFileUpload:true},()=>{
      setTimeout(()=>{
        this.setState({renderFileUpload:false})
      },200)
    })
  }

  deleteFile = (index) => {
    const { mappedCampaigns } = this.state;
    const list = [...mappedCampaigns];
    list[index]["url"] = "";
    this.setState({ mappedCampaigns: list });
  }

  handleApply = async () => {
    const { form } = this.state;
    const { match: { params: { id } } } = this.props;
    let { errors, valid } = handleError(form, formFields);

    // console.log(errors,valid);

    // console.log(form,valid,errors);
    let isValidList = true;
    if (valid) {
      // this.toggleModal(confirmationMessage);
      this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes.", toastStatus: ""  });
    } else {
      // let require = { action: { confirmationMessage: 'All Fields Are Required', type: 'error' } };
      // this.toggleModal(require);
      this.setState({ enableToast: true,  toastMsg: "All Fields are Required", toastStatus: "Fail"  });

      this.setState({ errors: errors, submited: true });

    }
  }


  // =========== modal changes ==========
  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  confirmationCallbackModel = (id) => {
    this.setState({ enableToast: false });
    if (id != undefined) {
      this.updateRO();
    } else {
      this.createRO();
    }
  }

  handleToastStatus = (status) => {
    this.setState({ enableToast: status },()=>{
      this.renderFileUploadButton();
    });
  }

  handleAction = (row, action) => {
    if (action.type === "edit") {
      this.deleteCampaign(row.campaignId);
    } 
  };


  render() {
    var dateNew = "2023-09-22"
    const maxDate = new Date();
    const { confirmationOpen, confirmationInfo, submited, errors, touched, form, editMode, advertiserFilter, roForm, categoryData, subCategoryData, primaryGoalData, secondaryGoalData, mappedCampaigns=[], enableToast, toastStatus, toastMsg, confirmationMsg,renderFileUpload } = this.state;
    const { ioAdvertisersReport, match: { params: { id } }, match, preSignInData } = this.props;
    // console.log("form",form)

    let campaignsMapped = _.cloneDeep(mappedCampaigns);

    campaignsMapped = campaignsMapped.map((dataf,index)=>({...dataf,index:index}))

    let isDisabledForView = match.path.includes(routes.ro.viewRo);


    // code for table data in Ro ********************************

    let clonedCampainOptions = cloneDeep(campaignOptions);


    clonedCampainOptions.columns.forEach((dataC,index)=>{
      if(dataC.label == 'Dashboard Thumbnail'){
        clonedCampainOptions.columns[index].component = (row) => <div>
        {
          row.url != '' ? <div className='mappedImg'><img src={row.url} />
          {
            !isDisabledForView && 
            <button disabled={isDisabledForView} onClick={() => this.deleteFile(row.index)}>
              <i className="mdi mdi-close text-dark"></i>
            </button>
          }
            
          </div> : !renderFileUpload &&
            <input disabled={isDisabledForView} name="url" accept="image/*" className='w-100'
              onChange={(e) => this.filesUpload(e, row.index)} type="file" />
        }
      </div>
      }
    })

    if(isDisabledForView){
      clonedCampainOptions.actionsThead = false;
    }

    // ******************************************************************

    return (
      <>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}

        {
          enableToast &&
          <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={`${routes.containers.goals}/${routes.containers.ro}`}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            outSideClickEnable = {false}
          />
        }

        <div className="main-panel ion add-margin-adj">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row justify-content-center mt-3">
              <div className="col-md-12 grid-margin">

                <Card>
                  <div className="d-flex justify-content-end">
                    <Link to={'/' + routes.mainRoute + '/' + routes.containers.goals + '/' + routes.containers.ro}><button type="button" className="btn btn-primary"> <i className="mdi mdi-keyboard-backspace"></i>Go Back to Goals</button>
                    </Link>
                  </div>
                {/* </Card>
                <Card> */}
                  <div className='row'>
                    <div className="col-md-6">
                    {/* {
                        form[formFields.advertiserId.key] ?
                          <div className='custom-test-select new'>
                            <label for="cars">Advertiser <span className='text-danger'>*</span></label>
                            <select name="advertiserId" onChange={this.handleChange}>
                              <option value="Select" disabled>Select</option>
                              {
                                advertiserFilter.map(option => option.key == form[formFields.advertiserId.key] ?
                                  <option value={option.key} selected>{option.value}</option> : <option value={option.key}>{option.value}</option>
                                )
                              }
                            </select>
                          </div>
                          : <div className='custom-test-select'>
                            <label for="cars">Advertiser <span className='text-danger'>*</span></label>
                            <select name="advertiserId" onChange={this.handleChange} className={errors.advertiserId.required ? "has-error" : ""}>
                            <option value="Select" >Select</option>
                              {
                                advertiserFilter.map(option =>
                                  <option value={option.value}>{option.value}</option>
                                )
                              }
                            </select>
                            <span className='error-message'>{errors.advertiserId.required ? "This Field is required" : ""}</span>
                          </div>
                      } */}


                    {
                      form[formFields.advertiserId.key] ? (
                          <div className='custom-test-select new'>
                            <label htmlFor="cars">Advertiser <span className='text-danger'>*</span></label>
                            <select className={`${advertiserFilter.length == 1 ? ' bg-secondary' : ''}`}
                             disabled={advertiserFilter.length == 1} name="advertiserId" value={form[formFields.advertiserId.key]} onChange={this.handleChange}>
                              <option value="" disabled>Select</option>
                              {
                                advertiserFilter.map(option => option.key == form[formFields.advertiserId.key] ?
                                  <option value={option.key} selected>{option.value}</option> : <option value={option.key}>{option.value}</option>
                                )
                              }
                            </select>
                          </div>
                        ) : (
                          <div className='custom-test-select'>
                            <label htmlFor="cars">Advertiser <span className='text-danger'>*</span></label>
                            <select name="advertiserId" value={advertiserFilter.length > 0 ? advertiserFilter[0].key : ""} onChange={this.handleChange} className={errors.advertiserId.required ? "has-error" : ""}>
                            <option value="Select" >Select</option>
                              {
                                advertiserFilter.map(option => (
                                  <option key={option.key} value={option.key}>
                                    {option.value}
                                  </option>
                                ))
                              }
                            </select>
                            <span className='error-message'>{errors.advertiserId.required ? "This Field is required" : ""}</span>
                          </div>
                        )
                      }
                    </div>

                    <div className="col-md-6">
                      <Input
                        onChange={this.handleChange}
                        onBlur={this.handleTouch}
                        value={form[formFields.roName.key]}
                        setting={formFields[formFields.roName.key]}
                        error={errors[formFields.roName.key]}
                        submited={submited}
                        touched={touched[formFields.roName.key]}
                        disabled={id ? true : false}
                      />
                    </div>

                    <div className="form-group col-md-6">
                      {
                        form[formFields.campaigncategory.key] ?
                          <div className='custom-test-select new'>
                            <label for="cars">Category <span className='text-danger'>*</span></label>
                            <select disabled={isDisabledForView} className={`${isDisabledForView ? 'bg-secondary' :''}`} name="campaigncategory" onChange={this.handleChange}>
                              <option value="Select" disabled>Select</option>
                              {
                                categoryData.map(option => option.id === form[formFields.campaigncategory.key] ?
                                  <option value={option.text} selected>{option.text}</option> : <option value={option.text}>{option.text}</option>
                                )
                              }
                            </select>
                          </div>
                          : <div className='custom-test-select'>
                            <label for="cars">Category <span className='text-danger'>*</span></label>
                            <select name="campaigncategory"  onChange={this.handleChange} className={errors.campaigncategory.required ? "has-error" : ""}>
                              <option value="Select">Select</option>
                              {
                                categoryData.map(option =>
                                  <option value={option.text}>{option.text}</option>
                                )
                              }
                            </select>
                            <span className='error-message'>{errors.campaigncategory.required ? "This Field is required" : ""}</span>
                          </div>
                      }
                    </div>

                    {/* <div className="col-md-6 ">
                      {
                        form[formFields.subCampaigncategory.key] ?
                          <div className='custom-test-select new'>
                            <label for="cars">Sub-Category <span className='text-danger'>*</span></label>
                            <select name="subCampaigncategory" onChange={this.handleChange} >
                              <option value="" disabled >Select</option>
                              {
                                subCategoryData.map(option => option.categoryID === form[formFields.subCampaigncategory.key] ?
                                  <option value={option.text} selected>{option.text}</option> : <option value={option.text}>{option.text}</option>

                                )
                              }
                            </select>
                          </div> : <div className='custom-test-select'>
                            <label for="cars">Sub-Category <span className='text-danger'>*</span></label>
                            <select name="subCampaigncategory" onChange={this.handleChange}  value ={form[formFields.subCampaigncategory.key]} className={errors.subCampaigncategory.required ? "has-error" : ""}>
                              <option value="">Select</option>
                              {
                                subCategoryData != undefined && subCategoryData.map(option =>
                                  <option value={option.text}>{option.text}</option>
                                )
                              }
                            </select>
                            <span className='error-message'>{errors.subCampaigncategory.required ? "This Field is required" : ""}</span>
                          </div>
                      }
                    </div> */}
                    <div className="col-md-6 ">
                        <div className='custom-test-select new'>
                        <label htmlFor="cars">Sub-Category <span className='text-danger'>*</span></label>
                        <select name="subCampaigncategory" onChange={this.handleChange} value={form[formFields.subCampaigncategory.key]} disabled={isDisabledForView} className={`${isDisabledForView ? 'bg-secondary' :''} ${errors.subCampaigncategory.required ? "has-error" : ""}`} >
                          <option value="" disabled>Select</option>
                          {subCategoryData && subCategoryData.map(option => (
                            <option key={option.categoryID} value={option.text} selected={form[formFields.subCampaigncategory.key] === option.text}>
                              {option.text}
                            </option>
                          ))}
                        </select>
                        <span className='error-message'>{errors.subCampaigncategory.required ? "This Field is required" : ""}</span>
                      </div>
                    </div>

                    {/* <div className='row col-md-12  mb-3 mt-4'> */}
                      <div className="col-md-6 ">
                    {/* 
                        {
                          form[formFields.primaryGoal.key] ?
                            <div className='custom-test-select new'>
                              <label for="cars" className='my-2'>Primary Goal <span className='text-danger'>*</span></label>
                              <select name="primaryGoal" onChange={this.handleChange}>
                                <option value="Select" disabled>Select</option>
                                {
                                  primaryGoalData.map(option => option.id === form[formFields.primaryGoal.key] ?
                                    <option value={option.value} selected>{option.value}</option> : <option value={option.value}>{option.value}</option>

                                  )
                                }
                              </select>
                            </div> : <div className='custom-test-select'>
                              <label for="cars" className='my-2'>Primary Goal <span className='text-danger'>*</span></label>
                              <select name="primaryGoal" onChange={this.handleChange} className={errors.primaryGoal.required ? "has-error" : ""}>
                                <option value="Select">Select</option>
                                {
                                  primaryGoalData != undefined && primaryGoalData.map(option =>
                                    <option value={option.value}>{option.value}</option>
                                  )
                                }
                              </select>
                              <span className='error-message'>{errors.primaryGoal.required ? "This Field is required" : ""}</span>
                            </div>
                        } */}


                      <div className='custom-test-select new'>
                        <label htmlFor="cars" className='my-2'>Primary Goal <span className='text-danger'>*</span></label>
                        <select name="primaryGoal" onChange={this.handleChange} value={form[formFields.primaryGoal.key]} disabled={isDisabledForView} className={`${isDisabledForView ? 'bg-secondary' :''} ${errors.primaryGoal.required ? "has-error" : ""}`}>
                          <option value="" disabled>Select</option>
                          {
                            primaryGoalData.map(option => (
                              <option key={option.id} value={option.id}>
                                {option.value}
                              </option>
                            ))
                          }
                        </select>
                        <span className='error-message'>{errors.primaryGoal.required ? "This Field is required" : ""}</span>
                      </div>

                      </div>
                      <div className="col-md-6">
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.targetValuePrimary.key]}
                          setting={formFields[formFields.targetValuePrimary.key]}
                          error={errors[formFields.targetValuePrimary.key]}
                          submited={submited}
                          touched={touched[formFields.targetValuePrimary.key]}
                          disabled={isDisabledForView}
                        />
                      </div>
                      {/* <div className="col-md-4">
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.tolerancePrimary.key]}
                          setting={formFields[formFields.tolerancePrimary.key]}
                          error={errors[formFields.tolerancePrimary.key]}
                          submited={submited}
                          touched={touched[formFields.tolerancePrimary.key]}
                        />
                      </div> */}


                      <div className="col-md-6">
                        {
                          form[formFields.secondryGoal.key] ?
                            <div className='custom-test-select new'>
                              <label for="cars" className='mt-2 mb-0'>Secondary Goal
                               {/* <span className='text-danger'>*</span> */}
                               </label>
                               <span style={{color: 'rgba(25, 37, 35, 0.54)',fontSize: 11,display: 'block'}}>Optional</span>
                              <select style={{marginTop:7}} name="secondryGoal"  disabled={isDisabledForView} className={`${isDisabledForView ? 'bg-secondary' :''}`} onChange={this.handleChange} value={form[formFields.secondryGoal.key]}>
                                <option value="">Select</option>
                                {
                                  secondaryGoalData.length > 0 && secondaryGoalData.map(option => option.id === form[formFields.secondryGoal.key] ?
                                    <option value={option.id} selected>{option.value}</option> : <option value={option.value}>{option.value}</option>
                                  )
                                }
                              </select>
                            </div> : <div className='custom-test-select'>
                              <label for="secondryGoal" className='mt-2 mb-0'>Secondary Goal
                               {/* <span className='text-danger'>*</span> */}
                               </label>
                               <span style={{color: 'rgba(25, 37, 35, 0.54)',fontSize: 11,display: 'block'}}>Optional</span>
                              {/* <label for="secondryGoal" class="col-sm-6 col-form-label pt-2" style={{paddingBottom:12}}>Secondary Goal<br/><span class="small" style={{color: "rgba(25, 37, 35, 0.54)"}}>Optional</span></label> */}
                              <select style={{marginTop:7}} name="secondryGoal" value={form[formFields.secondryGoal.key]} onChange={this.handleChange} disabled={isDisabledForView} className={`${isDisabledForView ? 'bg-secondary' :''} ${errors.secondryGoal.required ? "has-error" : ""}`}>
                                <option value="">Select</option>
                                {
                                  secondaryGoalData != undefined && secondaryGoalData.map(option =>
                                    <option value={option.value}>{option.value}</option>
                                  )
                                }
                              </select>
                              <span className='error-message'>{errors.secondryGoal.required ? "This Field is required" : ""}</span>

                            </div>
                        }
                      </div>

                      <div className="col-md-6">
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.targetValueSecondry.key]}
                          setting={formFields[formFields.targetValueSecondry.key]}
                          error={errors[formFields.targetValueSecondry.key]}
                          submited={submited}
                          touched={touched[formFields.targetValueSecondry.key]}
                          disabled={isDisabledForView}
                        />
                      </div>
                      {/* <div className="col-md-4">
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.toleranceSecondry.key]}
                          setting={formFields[formFields.toleranceSecondry.key]}
                          error={errors[formFields.toleranceSecondry.key]}
                          submited={submited}
                          touched={touched[formFields.toleranceSecondry.key]}
                        />
                      </div> */}
                    {/* </div> */}

                    {/* <div className="col-md-4">
                      <Input
                        onChange={this.handleChange}
                        onBlur={this.handleTouch}
                        value={form[formFields.budget.key]}
                        setting={formFields[formFields.budget.key]}
                        error={errors[formFields.budget.key]}
                        submited={submited}
                        touched={touched[formFields.budget.key]}
                      />
                    </div> */}

                    
                    <div className="col-md-6">
                      {
                        form[formFields.status.key] ?
                          <SelectNew
                            onChange={this.handleChange}
                            // onBlur={this.handleTouch}
                            onBlur={()=>{}}
                            value={form[formFields.status.key]}
                            setting={formFields[formFields.status.key]}
                            error={errors[formFields.status.key]}
                            submited={submited}
                            touched={touched[formFields.status.key]}
                            options={sortArray(roStaus)}
                            defaultValue={roStaus}
                            disabled={isDisabledForView}
                          /> : <div className='custom-test-select' style={{paddingTop:9}}>
                            <label for="cars" style={{paddingBottom:10}}>Status <span className='text-danger'>*</span></label>
                            <select name="status"  onChange={this.handleChange} defaultValue={roStaus[0].value} className={errors.status.required ? "has-error" : ""}>
                              <option disabled value="Select">Select</option>
                              {
                                roStaus.map(option =>
                                  <option value={option.value}>{option.value}</option>
                                )
                              }
                            </select>
                            <span className='error-message'>{errors.status.required ? "This Field is required" : ""}</span>
                          </div>
                      }
                    </div>
                    {/* <div className="col-md-8" id="TrendsDateElement">
                      <div className="row">
                        <div className="col-md-6">
                          <Datepicker
                            onChange={this.handleChange}
                            onBlur={this.handleTouch}
                            value={form[formFields.startDate.key] || ''}
                            setting={formFields[formFields.startDate.key]}
                            error={errors[formFields.startDate.key]}
                            submited={submited}
                            touched={touched[formFields.startDate.key]}
                            minDate={new Date()}
                            maxDate={form.endDate}
                            // showDisabledMonthNavigation
                            disabled={id ? true : false}
                            isClearable={id ? false : true}
                          />
                        </div>
                        <div className="col-md-6">
                          <Datepicker
                            onChange={this.handleChange}
                            onBlur={this.handleTouch}
                            value={form[formFields.endDate.key] || ''}
                            setting={formFields[formFields.endDate.key]}
                            error={errors[formFields.endDate.key]}
                            submited={submited}
                            touched={touched[formFields.endDate.key]}
                            // disabled={form.startDate ? false : true}
                            // minDate={form.startDate}
                            sDate={form.startDate}
                            minDate={id ? new Date() : form.startDate}
                            disabled={isDisabledForView}
                            // showDisabledMonthNavigation
                          />

                        </div>
                      </div>
                    </div> */}


                  

                    {
                      id &&
                      <>
                        {
                          campaignsMapped != undefined && campaignsMapped.length > 0 &&
                          <div className="col-md-12 p-0 btn-block text-left mt-4 badgeText">
                            <p style={{ fontSize: '14px' }}>Campaign Targeting</p>
                          </div>
                        }
                        {
                          campaignsMapped != undefined && campaignsMapped.length > 0 &&
                          <div className="table-responsive mt-4">
                          <Table
                          options={clonedCampainOptions}
                          data={campaignsMapped}
                          handelAction={this.handleAction}
                        
                        />
                        </div>
                        }
                        {/* {
                          mappedCampaigns != undefined && mappedCampaigns.length > 0 && mappedCampaigns.map((mapped, index) =>

                            <div className='row w-100'>
                              <div className='col-md-4 mt-3 unmappedCamp'>
                                <label>Platform</label>
                                <input type='text' className='form-control' value={mapped.platform} disabled />
                              </div>
                              <div className='col-md-4 mt-3 unmappedCamp'>
                                <label>Campaign Name</label>
                                <input type='text' className='form-control' value={mapped.name} disabled />

                              </div>
                              <div className='col-md-3 mt-3'>
                                <label htmlFor="getUpload" className="col-sm-6 col-form-label">Creative</label>
                                <div>
                                  {
                                    mapped.url != '' ? <div className='mappedImg'><img src={mapped.url} />
                                      <button onClick={() => this.deleteFile(index)}>
                                        <i className="mdi mdi-close text-dark"></i>
                                      </button>
                                    </div> :
                                      <input name="url" accept="image/*" className='w-100'
                                        onChange={(e) => this.filesUpload(e, index)} type="file" />
                                  }
                                </div>
                              </div>
                              <div className='col-md-1  flexClass'>
                              <button className="btn-remove" onClick={() => this.deleteCampaign(mapped.campaignId)} style={{ top: '18px' }} ><i className='mdi mdi-delete'></i></button>
                              </div>
                            </div>
                          )
                        } */}
                      </>
                    }

                    {
                      !isDisabledForView
                      &&
                      <div className="form-group row mt-5" style={{ width: "100%" }}>
                        <div className="col-sm-12">
                          <center>
                            {
                              id ?
                                <button type="submit" onClick={() => this.handleApply()} className="btn btn-primary">Update</button>
                                :
                                <button type="submit" onClick={() => this.handleApply()} className="btn btn-primary">Save</button>
                            }
                            <Link to={'/' + routes.mainRoute + '/' + routes.containers.goals + '/' + routes.containers.ro}><button type="button" className="btn btn-secondary ml-2">Cancel</button></Link>
                          </center>
                        </div>
                      </div>
                    }
                   
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  state => ({
    configurationList: get(state, 'app.configurationData.responseList', []),
    ioAdvertisersReport: get(state, 'app.ioAdvertisersReport.responseList', []),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', ''),
    preSignInData: get(state, 'app.preSignInData.responseList', []),
    countUnmapped:get(state,"app.countUnmapped.response.count")
  }),
  {
    addIoReportAction,
    getIoAdvertisersReportAction,
    getIoEditIdReportAction,
    getCategoryAction,
    getSUbCategoryAction,
    getPrimaryGoalAction,
    getSecondaryGoalAction,
    createRoAction,
    getRoListByIdAction,
    updateRoAction,
    uploadFileAction,
    getCountUnMappedCampaignAction
  }
)(AddRo);

// ----*  IO propTypes * ----
AddRo.propTypes = {
  addIoReportAction: PropTypes.func,
  getIoAdvertisersReportAction: PropTypes.func,
  configurationList: PropTypes.array,
  ioAdvertisersReport: PropTypes.array,
};